import { defineType, defineField } from 'sanity';
import { MembershipRankSectionSchema } from './membership-rank-section';
import { CollectionPointSectionSchema } from './collecting-point-section';
import { CurrentBenefitSectionSchema } from './current-benefit-section';

const collectingPointSection = CollectionPointSectionSchema('collectingPointSection', 'Collecting Point Section');

export default defineType({
	name:   'sustainableMovePage',
	title:  'Sustainable Move Page',
	type:   'document',
	fields: [
		defineField({
			name:   'heading',
			title:  'Heading',
			type:   'object',
			fields: [
				defineField({
					name:  'title',
					title: 'Title',
					type:  'localizedText',
				}),
				defineField({
					name:  'description',
					title: 'Description',
					type:  'localizedText',
				}),
			],
		}),
		defineField(CurrentBenefitSectionSchema),
		defineField(collectingPointSection),
		defineField(MembershipRankSectionSchema),
	],
	preview: { prepare: () => ({ title: 'Sustainable Move Page' }) },
});